<app-connections [state]="connections$ | async">
</app-connections>
